export default "__VITE_ASSET__d8f9c135__"